// @ts-nocheck

import React, { useCallback, useState } from 'react';
import { useMemo } from 'react';
import { createPortal } from 'react-dom';

import { Target } from '../../../../client';
import MobileModal from '../../../../components/MobileModal';
import Modal from '../../../../components/Modal';
import { ModalContentSpacing } from '../../../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../../../DOMElements';
import useRouter from '../../../../hooks/useRouter';
import { ZIndices } from '../../../../styled-components/dark/common';
import BetslipOptionsAddToBasketModalContainer from '../BetslipOptionsAddToBasketModal/BetslipOptionsAddToBasketModalContainer';

const BetslipOptionsRouterShare = () => {
  const { location, history } = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  const hashBetslipRef = useMemo(() => {
    const isShareHash = location.hash.indexOf('#betshare') === 0;

    if (isShareHash) {
      setIsOpen(true);
      return location.hash.split('/')[1];
    }
    return null;
  }, [location.hash]);

  const shortId = useMemo(() => {
    return new URLSearchParams(location.search).get('shortURLId');
  }, [location.search]);

  const onCloseModal = useCallback(() => {
    setIsOpen(false);
    history.replace(location.pathname);
  }, [history, location.pathname]);

  return !!shortId && hashBetslipRef ? (
    <>
      {Target.__MOBILE__ ? (
        <MobileModal isOpen={isOpen} onClose={onCloseModal} fullHeight>
          {hashBetslipRef ? (
            <BetslipOptionsAddToBasketModalContainer
              betslipReference={hashBetslipRef}
              shortUrlId={shortId}
              onCloseModal={onCloseModal}
            />
          ) : null}
        </MobileModal>
      ) : null}
      {!Target.__MOBILE__ && isOpen
        ? createPortal(
            <Modal
              backgroundColor={'#000000'}
              contentSpacing={ModalContentSpacing.NONE}
              hasOverlay
              closeOnOutsideClick
              closeOnEsc
              onClose={onCloseModal}
              hasCloseButton
              disableScrollView
              contentScrollable
              noOverflowHidden
              hasBorderRadius
              zIndex={ZIndices.lineUpModal}
              forbidBackgroundScrolling
            >
              {hashBetslipRef ? (
                <BetslipOptionsAddToBasketModalContainer
                  betslipReference={hashBetslipRef}
                  shortUrlId={shortId}
                  onCloseModal={onCloseModal}
                />
              ) : null}
            </Modal>,
            getPortalRootDOMElement(),
          )
        : null}
    </>
  ) : null;
};

const BetslipOptionsRouterSwitch = () => {
  return (
    <>
      <BetslipOptionsRouterShare />
    </>
  );
};

export default BetslipOptionsRouterSwitch;
